import {unRestangularize} from 'shared/utils/data-service-utils';
import {ngAsync} from 'shared/utils/ng-@decorators';
import type {RichDocument} from 'typings/portaro.be.types';

export class VisitedDocumentsDataService {
    public static serviceName = 'visitedDocumentsDataService';

    /*@ngInject*/
    constructor(private Restangular: Restangular.IService) {
    }

    @unRestangularize()
    @ngAsync()
    public async getVisitedDocuments(withLastVisited?: boolean): Promise<RichDocument[]> {
        return this.Restangular
                   .one('documents', 'visited')
                   .get({withLast: withLastVisited});
    }
}
